import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import NewsTableRow from './NewsTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PropTypes from 'prop-types';

class NewsTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    render() {
        let btnNuovaNews = null;
        if (this.props.readOnly == false){
            btnNuovaNews =<Link to={`/app/news/new`}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="plus icon"></i> Nuova Notizia
                    </div>
                </Link>
        }
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled compact table">
            <thead>
            <tr><th colSpan="5">
                {btnNuovaNews}

                <a href="#" onClick={(ev) => (this.props.onChangeOrder(''))}>
                    <i className="sort icon"></i> Ripristina ordinamento standard
                </a>
                
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="idNews"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >ID</TableColumnOrdered>
                <TableColumnOrdered
                    name="dataPubblicazione"
                    orderActive={this.props.tableOrderingField === "dataPubblicazione"}
                    orderFields="dataPubblicazione"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Data Pubblicazione</TableColumnOrdered>
                <TableColumnOrdered
                    name="dataAggiornamento"
                    orderActive={this.props.tableOrderingField === "dataAggiornamento"}
                    orderFields="dataAggiornamento"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Data Aggiornamento</TableColumnOrdered>
                <TableColumnOrdered
                    name="titolo"
                    orderActive={this.props.tableOrderingField === "titolo"}
                    orderFields="titolo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Contenuto</TableColumnOrdered>
                <TableColumnOrdered
                    name="presentazione"
                    orderActive={this.props.tableOrderingField === "presentazione"}
                    orderFields="g.presentazione"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Presentazione entro</TableColumnOrdered>
                <TableColumnOrdered
                    name="sopralluogo"
                    orderActive={this.props.tableOrderingField === "sopralluogo"}
                    orderFields="g.sopralluogo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Sopralluogo</TableColumnOrdered>
                <TableColumnOrdered
                    name="chiarimenti"
                    orderActive={this.props.tableOrderingField === "chiarimenti"}
                    orderFields="g.chiarimenti"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Chiarimenti</TableColumnOrdered>                
                <TableColumnOrdered
                    name="stato"
                    orderActive={this.props.tableOrderingField === "stato"}
                    orderFields="stato"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={false}
                >Stato</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((news) => (
                <NewsTableRow
                    news={news}
                    key={news.idNews}
                    onDeleteItem={this.props.onDeleteItem}
                    onResetVisibility={this.props.onResetVisibility}
                    onResetVisibilityUser={this.props.onResetVisibilityUser}
                    readOnly={this.props.readOnly}
                />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

NewsTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onResetVisibility: PropTypes.func,
    onResetVisibilityUser: PropTypes.func,
    readOnly: PropTypes.bool
}
export default NewsTable;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsTable.js
 **/